import React, { useEffect, useState, useContext, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import './OrderConfirmation.css';

const OrderConfirmation = () => {
    const { sessionToken } = useParams();

    const { user, setUser } = useContext(UserContext);
    const [userChecked, setUserChecked] = useState(false);
    const [sessionTokenData, setSessionTokenData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const hasFetchedSessionData = useRef(false);

    const navigate = useNavigate();

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (!user && storedUser) {
            const parsedUser = JSON.parse(storedUser);
            if (new Date().getTime() > parsedUser.expiry) {
                localStorage.removeItem('user');
                setUser(null);
                alert('Session expired. Please log in again.');
                navigate('/login', { state: { redirectTo: `/checkout/${sessionToken}` } });
            } else {
                setUser(parsedUser);
            }
        } else if (!user) {
            navigate('/login', { state: { redirectTo: `/checkout/${sessionToken}` } });
        }
        setUserChecked(true);
    }, [user, setUser, navigate, sessionToken]);


    useEffect(() => {
        if (!hasFetchedSessionData.current && !sessionTokenData && user) {
            hasFetchedSessionData.current = true;
            const fetchSessionData = async () => {
                setLoading(true);
                try {
                    const requestBody = {
                        email: user.email
                    };

                    const response = await fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Checkout/GetCheckoutFieldsAndGetSearchSessionToken', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(requestBody),
                    });

                    if (!response.ok) {
                        throw new Error('Failed to fetch session details');
                    }

                    const data = await response.json();
                    if (data) {

                        data.cartItems = [];

                        var numCartItemsSave = data.numberOfCartItems;
                        var paymentSessionTokenSave = data.paymentSessionToken;

                        // batch get cart items
                        var numberOfCartDownloads = Math.ceil(numCartItemsSave / 10); // 10 cart items each time

                        for (let downloadCounter = 0; downloadCounter < numberOfCartDownloads; downloadCounter++) {

                            const startItem = downloadCounter * 10;
                            const endItem = Math.min(startItem + 9, numCartItemsSave - 1);

                            const cartItemRequestBody = {
                                paymentSessionToken: paymentSessionTokenSave,
                                startCartItemNumberInclusive: startItem,
                                endCartItemNumberInclusive: endItem
                            };

                            const cartItemsResponse = await fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Checkout/GetCheckoutFieldsAndGetSearchSessionToken_CartItems', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(cartItemRequestBody),
                            });

                            if (!cartItemsResponse.ok) {
                                throw new Error('Failed to fetch session details');
                            }

                            const dataCartItems = await cartItemsResponse.json();

                            dataCartItems.forEach((item, index) => {
                                data.cartItems.push(item);
                            });
                        }

                        setSessionTokenData(data);
                    } else {
                        setError('No session data found or access denied.');
                    }
                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };
            fetchSessionData();
        }
    }, [userChecked, user, sessionTokenData]);

    useEffect(() => {
        if (!sessionTokenData) {
            return;
        }

        const handleCompletedPayment = async () => {
            if (!user || !sessionTokenData) return;

            sessionTokenData.cartItems.forEach((item, index) => {
                item.imageBase64 = null;
            });

            const requestBody = {
                userPaymentSessionDto: sessionTokenData
            };

            try {
                const response = await fetch("https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Checkout/HandleCompletedPayment", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestBody),
                });

                if (!response.ok) throw new Error("Failed to display the order complete details.");

            } catch (error) {
                alert(error.message);
            }
        };

        handleCompletedPayment();
    }, [sessionTokenData]);

    if (!sessionTokenData) {
        return <div className="error-message">Please wait a few seconds.</div>;
    }

    return (
        <div className="order-confirmation-container">
            <h2>Payment Complete!</h2>
            <div className="order-details">
                <p><strong>Total:</strong> ${(sessionTokenData.cartTotalAmount + sessionTokenData.shippingAmount).toFixed(2)}</p>
            </div>
        </div>
    );
};

export default OrderConfirmation;